module.exports = __webpack_public_path__ + "img/poziom1.8d13846b.svg";